module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "spacer--small"
  }, [_c('h2', {
    staticClass: "caps center text--light spacer--tiny"
  }, [_vm._v("\n      " + _vm._s(_vm.category.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "column--half-br-fluid center"
  }, [_c('h3', {
    staticClass: "text--light bold"
  }, [_vm._v("\n        " + _vm._s(_vm.category.korean.subCategory.english) + "\n        "), _c('span', {
    staticClass: "kr-sans"
  }, [_vm._v("\n          " + _vm._s(_vm.category.korean.subCategory.korean) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('img', {
    staticClass: "absolute show-hover spacer--tiny",
    attrs: {
      "src": ("/static/images/type-categories/" + (_vm.category.id) + "-kr-hover.svg"),
      "alt": ("Korean " + (_vm.category.name))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "spacer--tiny",
    attrs: {
      "src": ("/static/images/type-categories/" + (_vm.category.id) + "-kr.svg"),
      "alt": ("Korean " + (_vm.category.name))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--light caption caps"
  }, [_vm._v("Typeface")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caps bold text--lightpink"
  }, [_vm._v("\n        " + _vm._s(_vm.category.korean.typeface) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "column--single serif caption--max-width text--darkgreen left spacer--small"
  }, [_vm._v("\n        " + _vm._s(_vm.category.korean.description) + "\n      ")]), _c('div', {
    staticClass: "spacer--small-mobile"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column--half-br-fluid center"
  }, [_c('h3', {
    staticClass: "text--light bold"
  }, [_vm._v("\n        " + _vm._s(_vm.category.english.subCategory) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('img', {
    staticClass: "absolute show-hover spacer--tiny",
    attrs: {
      "src": ("/static/images/type-categories/" + (_vm.category.id) + "-en-hover.svg"),
      "alt": ("English " + (_vm.category.name))
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "spacer--tiny",
    attrs: {
      "src": ("/static/images/type-categories/" + (_vm.category.id) + "-en.svg"),
      "alt": ("English " + (_vm.category.name))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text--light caption caps"
  }, [_vm._v("Typeface")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "caps bold text--lightpink"
  }, [_vm._v("\n        " + _vm._s(_vm.category.english.typeface) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "column--single serif caption--max-width text--darkgreen left spacer--small"
  }, [_vm._v("\n        " + _vm._s(_vm.category.english.description) + "\n      ")])])]), _vm._v(" "), (!_vm.isLast) ? _c('div', {
    staticClass: "clear rule spacer--medium"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7063b9d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TypeCategory.vue
// module id = 148
// module chunks = 0